(function () {
  function onDocumentReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  function onWindowLoad(callback) {
    if (document.readyState === 'complete') {
      callback();
      return;
    }

    window.addEventListener('load', callback, { once: true });
  }

  function runWhenIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1500 });
      return;
    }

    window.setTimeout(callback, 1);
  }

  function optimizeImage(image) {
    if (!(image instanceof HTMLImageElement)) {
      return;
    }

    if (image.loading === 'lazy') {
      if (!image.getAttribute('decoding')) {
        image.decoding = 'async';
      }

      if (!image.getAttribute('fetchpriority')) {
        image.setAttribute('fetchpriority', 'low');
      }
    }
  }

  function optimizeImages(root) {
    if (!root) {
      return;
    }

    if (root instanceof HTMLImageElement) {
      optimizeImage(root);
      return;
    }

    if (typeof root.querySelectorAll !== 'function') {
      return;
    }

    root.querySelectorAll('img').forEach(optimizeImage);
  }

  function observeImageMutations() {
    if (!('MutationObserver' in window)) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          optimizeImages(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function loadDeferredStyles() {
    document.querySelectorAll('link[data-load-on="window-load"][data-href]').forEach(function (link) {
      if (link.dataset.loaded === 'true') {
        return;
      }

      link.dataset.loaded = 'true';
      link.rel = 'stylesheet';
      link.href = link.dataset.href;
      link.media = 'all';
    });
  }

  function copyScriptAttributes(source, target) {
    var id = source.getAttribute('id');
    var nonce = source.getAttribute('nonce');
    var integrity = source.getAttribute('integrity');
    var crossOrigin = source.getAttribute('crossorigin');
    var referrerPolicy = source.getAttribute('referrerpolicy');

    if (id) {
      target.id = id + '--loaded';
    }

    if (nonce) {
      target.setAttribute('nonce', nonce);
    }

    if (integrity) {
      target.integrity = integrity;
    }

    if (crossOrigin) {
      target.crossOrigin = crossOrigin;
    }

    if (referrerPolicy) {
      target.referrerPolicy = referrerPolicy;
    }
  }

  function executeDeferredScript(placeholder) {
    return new Promise(function (resolve) {
      if (!placeholder.parentNode) {
        resolve();
        return;
      }

      var script = document.createElement('script');
      copyScriptAttributes(placeholder, script);

      if (placeholder.dataset.src) {
        script.src = placeholder.dataset.src;
        script.async = placeholder.dataset.async === 'true';

        if (!script.async) {
          script.async = false;
          script.defer = placeholder.dataset.defer === 'true';
        }

        script.onload = resolve;
        script.onerror = resolve;
      } else {
        script.text = placeholder.textContent || '';
      }

      placeholder.parentNode.insertBefore(script, placeholder.nextSibling);
      placeholder.remove();

      if (!placeholder.dataset.src) {
        resolve();
      }
    });
  }

  async function loadDeferredScripts() {
    var placeholders = Array.prototype.slice.call(
      document.querySelectorAll('script[data-load-on="window-load"]')
    );

    for (var index = 0; index < placeholders.length; index += 1) {
      var placeholder = placeholders[index];

      if (placeholder.dataset.loaded === 'true') {
        continue;
      }

      placeholder.dataset.loaded = 'true';
      await executeDeferredScript(placeholder);
    }
  }

  onDocumentReady(function () {
    optimizeImages(document);
    observeImageMutations();
  });

  onWindowLoad(function () {
    runWhenIdle(function () {
      loadDeferredStyles();
      loadDeferredScripts();
    });
  });
})();
